// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';
// Translations
import { DESCRIPTION, TITLE } from '../translations/header-layout-modal.translations';

const HEADER_LAYOUT_MODAL_COMPONENT_PROPS = {
  description: DESCRIPTION,
  id: ModalReferencesEnumeration.DROP_PROCESS,
  title: TITLE,
};

export { HEADER_LAYOUT_MODAL_COMPONENT_PROPS };
